/**
 * Lightweight `{placeholder}` interpolation. We intentionally do NOT support
 * ICU plural / select syntax in v1 — none of our v1 strings need it. Add a
 * proper ICU library when usage demands it.
 */

export type InterpolationParams = Record<string, string | number>;

export function interpolate(template: string, params?: InterpolationParams): string {
  if (!params) return template;
  return template.replace(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}
